<template>
  <div
    class="p-relative d-flex container"
    :style="{
      padding: blockPadding,
      minHeight: imageUrl ? 'auto' : '200px',
      justifyContent: imageAlign
    }"
  >
    <img
      v-if="imageUrl"
      class="image-block__image"
      :src="imageUrl"
      :width="width"
    />
  </div>
</template>

<script>
import { getImageUrl } from "@/lib/utils"
import { toPadding, withRatio, IMAGE_BASE_WIDTH } from "@shared/block-ratio"
import enumValidator from "@/lib/validators/enum-validator"

export default {
  props: {
    image: { type: Object, default: () => ({}) },
    align: {
      type: String,
      default: "center",
      validator: enumValidator(["left", "center", "right"])
    },
    widthRatio: {
      type: Number,
      default: 100
    },
    spaceXRatio: {
      type: Number,
      default: 0
    },
    spaceTopRatio: {
      type: Number,
      default: 0
    },
    spaceBottomRatio: {
      type: Number,
      default: 0
    }
  },

  computed: {
    blockPadding() {
      return toPadding(
        this.spaceTopRatio,
        this.spaceXRatio,
        this.spaceBottomRatio
      )
    },

    imageUrl() {
      return getImageUrl(this.image)
    },

    imageAlign() {
      return {
        left: "flex-start",
        center: "center",
        right: "flex-end"
      }[this.align]
    },

    width() {
      return withRatio(IMAGE_BASE_WIDTH, this.widthRatio)
    }
  },

  methods: {
    getImageUrl
  }
}
</script>

<style lang="scss" scoped>
.image-block__image {
  max-width: 100%;
}
</style>
